export default __webpack_public_path__ + "static/media/video.1ef00115.png";